import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../Service/axiosInstance";
import ListePays from "../Fonction/ListePays";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";

const InscriptionForm = ({ setUser }) => {
  const navigate = useNavigate();

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    mail: "",
    telephone: "",
    dateNaissance: "",
  });
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  // Mise à jour des champs
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "password") setPassword(value);
    else if (name === "confirmPassword") setConfirmPassword(value);
    else setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    if (!selectedCountry) {
      setError("Veuillez sélectionner un pays.");
      return;
    }

    setLoading(true);

    const dataToSubmit = {
      ...formData,
      motdepasse: password,
      pays: {
        idPays: selectedCountry.id,
        nom: selectedCountry.nom,
      },
    };

    try {
      const response = await axiosInstance.post(
        "/yourtravelshop/inscription",
        dataToSubmit
      );

      if (response.data.token && response.data.user) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        setUser(response.data.user);
        setSuccess(true);
        navigate("/Home");
      } else {
        setError(
          response.data.message || "Ce mail est déjà utilisé."
        );
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    } catch (err) {
      setError("Erreur lors de la connexion au serveur.");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } finally {
      setLoading(false);
    }
  };   

    return (
        <Container maxWidth="sm">
            <br /><br />
            <Box className="inscription-box">
                <Typography variant="h5" gutterBottom className="inscription-title">
                   <h2 style={{
                    fontFamily: 'Beyond',
                    fontSize: '50px',
                    color: '#000000',
                    }}>
                    Inscription
                </h2>                </Typography>
                {success && (
                    <Typography color="success.main" gutterBottom>
                        Inscription réussie ! Bienvenue dans notre liste clientèle.
                    </Typography>
                )}
                {error && (
                    <Typography color="error" gutterBottom>
                        {error}
                    </Typography>
                )}
                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        label="Nom"
                        name="nom"
                        value={formData.nom}
                        onChange={handleChange}
                        margin="normal"
                        required
                        className="inscription-input"
                    />
                    <TextField
                        fullWidth
                        label="Prenom"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleChange}
                        margin="normal"
                        required
                        className="inscription-input"
                    />
			<TextField
                        fullWidth
                        label="Date de naissance"
                        name="dateNaissance"
                        type="date"
                        value={formData.dateNaissance}
                        onChange={handleChange}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        required
                        className="inscription-input"
                    />
			<ListePays selectedCountry={selectedCountry} onSelectCountry={setSelectedCountry} />
			<TextField
                        fullWidth
                        label="Téléphone"
                        name="telephone"
                        type="tel"
                        value={formData.telephone}
                        onChange={handleChange}
                        margin="normal"
                        required
                        className="inscription-input"
                    />
                    <TextField
                        fullWidth
                        label="Email"
                        name="mail"
                        type="email"
                        value={formData.mail}
                        onChange={handleChange}
                        margin="normal"
                        required
                        className="inscription-input"
                    />
                    <TextField
                        fullWidth
                        label="Mot de passe"
                        name="password"
                        type="password"
                        value={password}
                        onChange={handleChange}
                        margin="normal"
                        required
                        className="inscription-input"
                    />
                    <TextField
                        fullWidth
                        label="Confirmer le mot de passe"
                        name="confirmPassword"
                        type="password"
                        value={confirmPassword}
                        onChange={handleChange}
                        margin="normal"
                        required
                        className="inscription-input"
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        className="inscription-button"
                        disabled={loading} // Désactiver le bouton pendant le chargement
                    >
                        {loading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "S'inscrire"
                        )}
                    </Button>
                </form>
            </Box>
            <br /><br /><br />
        </Container>
    );
};

export default InscriptionForm;
